import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/API_Client";
import CustomButton from "../CustomButton";
import { Fab, IconButton, Tooltip, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Link } from "react-router-dom";
import { colorBrandObject } from "../../../constants/brandings";

export default function ContentHeader({
  firstHeading,
  secondHeading,
  buttonPermissions,
  secondaryButtonPermissions,
  icon,
  buttonText,
  buttonType,
  buttonSize,
  buttonVariant,
  buttonOnclick,
  showFabButton,
  handleFabClick,
  fabButtonText,
  showTooltip,
  tooltipText,
  secondaryButtonText,
  secondaryButtonType,
  secondaryButtonSize,
  secondaryButtonVariant,
  secondaryButtonOnClick,
  contentWidth,
  buttonId,
  secondaryButtonId,
  secondaryIconButton,
  iconButton,
  url,
  showBackButton,
  backButton
}) {
  const { isAuthorizedPermission } = useAuth();
  const [mobileLayout, setMobileLayout] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width : 520px)");
    setMobileLayout(mediaQuery.matches);
    const updateShouldRenderMobileNavbar = (event) => {
      setMobileLayout(mediaQuery.matches);
    };
    mediaQuery.addEventListener("change", updateShouldRenderMobileNavbar);
  }, []);

  const shouldShowButton = buttonPermissions.every((permission) => {
    if (permission === null) return true;
    if (Array.isArray(permission)) {
      if (permission.length === 0) return true;
      return false;
    }
    return isAuthorizedPermission(permission) === true;
  });

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            width: contentWidth,
          }}
        >
          {showBackButton && <img src="/assets/offers/arrow-left.svg" alt="arrow" style={{ marginRight: "12px", cursor: "pointer" }} onClick={() => backButton()} />}
          {icon && <div
            style={{
              color: colorBrandObject?.primaryButtonColor,
              height: "24px",
              width: "24px",
              marginRight: "4px",
            }}
          >
            {icon}
          </div>}
          <div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Typography className="headerH3Medium font-black-highest">
                {firstHeading}
              </Typography>
              {showTooltip && (
                <Tooltip title={tooltipText} placement="right" arrow>
                  <IconButton
                    sx={{
                      "&:hover": { backgroundColor: "transparent" },
                    }}
                    disableFocusRipple
                    disableTouchRipple
                  >
                    <InfoOutlinedIcon
                      sx={{
                        height: "16px",
                        width: "16px",
                        border: "0px",
                        color: "black",
                      }}
                    />
                  </IconButton>
                </Tooltip>
              )}
            </div>
            <div style={{ display: "flex" }}>
              <Typography
                className="bodyB2RegularText font-black-high"
                style={{ marginTop: "6px" }}
              >
                {secondHeading}
              </Typography>
              {url && (
                <Link to={url} target="_blank">
                  <Typography
                    className="bodyB2SemiBold font-black-high"
                    style={{ marginTop: "6px", paddingLeft: "4px" }}
                  >
                    {url}
                  </Typography>
                </Link>
              )}
            </div>
          </div>
        </div>
        <div style={{ display: "flex", gap: "12px" }}>
          {buttonText && shouldShowButton && !mobileLayout && (
            <CustomButton
              text={buttonText}
              type={buttonType}
              size={buttonSize}
              variant={buttonVariant}
              onClick={buttonOnclick}
              id={buttonId}
              iconButton={iconButton}
            />
          )}
          {secondaryButtonText &&
            secondaryButtonPermissions?.every(
              (permission) => isAuthorizedPermission(permission) === true
            ) &&
            !mobileLayout &&
            secondaryButtonText && (
              <CustomButton
                text={secondaryButtonText}
                type={secondaryButtonType}
                size={secondaryButtonSize}
                variant={secondaryButtonVariant}
                onClick={secondaryButtonOnClick}
                id={secondaryButtonId}
                iconButton={secondaryIconButton}
              />
            )}
        </div>
      </div>
      {buttonPermissions.every(
        (permission) => isAuthorizedPermission(permission) === true
      ) &&
        showFabButton &&
        mobileLayout && (
          <div
            style={{
              position: "fixed",
              bottom: 20,
              right: 22,
              right: 22,
              zIndex: 999,
            }}
          >
            <Fab
              onClick={handleFabClick}
              variant="extended"
              sx={{
                backgroundColor: "#403e9f",
              }}
            >
              <AddIcon sx={{ mr: 1 }} />
              {fabButtonText}
            </Fab>
          </div>
        )}
    </>
  );
}

ContentHeader.defaultProps = {
  buttonPermissions: [],
  secondaryButtonPermissions: [],
};
